import React, { Component, useState, useEffect  } from "react";
import { useNavigate, useLocation } from 'react-router-dom'


{/*import "../css/login.css";*/}



function Appsmenu(props) {



useEffect(() => {
	
if (sessionStorage.getItem("USERNAME")==null || sessionStorage.getItem("USERNAME")=="null" || sessionStorage.getItem("USERNAME")==undefined || sessionStorage.getItem("USERNAME")==""){
	navigate("/");
	return;
	}//end if	
	
document.title =   "APS Dashboard";	




if(sessionStorage.getItem("USERNAME")==undefined || sessionStorage.getItem("USERNAME")==null || sessionStorage.getItem("USERNAME")=="")	
		navigate("/login");
	
},[]);



const navigate = useNavigate();	

const location = useLocation();
console.log('location.pathname: '+location.pathname);
console.log('window.location: '+window.location);


function openapp(e, apppath){
e.preventDefault(); 
//console.log('openapp resturl: '+sessionStorage.getItem("RESTURL") );
document.getElementsByTagName('body')[0].classList.remove("loginbody");	

if (apppath=="lbr_clr_xtl"){
	sessionStorage.setItem("XTL_NAME", "Board");
	sessionStorage.setItem("START_PAGE", "lbr_clr_xtl");
	}//end if

navigate('/'+apppath);

/*
, {
      state: {
        resturl: sessionStorage.getItem("RESTURL"),
		}
      }
*/

}//end func



/*
const AD_USER=(sessionStorage.getItem("AD_USER")=="null")?"":sessionStorage.getItem("AD_USER");
const username=(sessionStorage.getItem("USERNAME")==null)?"":sessionStorage.getItem("USERNAME");
*/

const AD_USER=sessionStorage.getItem("AD_USER")??"";
const username=sessionStorage.getItem("USERNAME")??"";

//const IRD_LOGIN_ID=(sessionStorage.getItem("IRD_LOGIN_ID")==null)?"":sessionStorage.getItem("IRD_LOGIN_ID");


    return (
		<>
		
	  		
       <div align="center"  className="numcols4-1" >
                <div className="rcorners">
                    <a href="#" onClick={(e)=>{openapp(e, 'startwptapp')}}  >
                    <table border="0" width="100%"  >
					<tbody>
                    <tr valign="top">
                    <td align="left" rowSpan="2" width="72"  >
                    <img src="img/searchdb.png" height="105" border="0" title="" />
                    </td>
                    <td align="left" className="boxtitle" >Apply for<br/>Work Permit</td>
                    </tr>
                    <tr>
                    <td align="left" className="boxtext" >Add New<br/>Work Permit Application</td>
                    </tr>
					</tbody>
                    </table>
                    </a>
                </div>
        </div>
        <div align="center"  className="numcols4-2" >
                <div className="rcorners">
                    <a href="#" onClick={(e)=>{openapp(e, 'wpapps')}}  >
                    <table border="0" width="100%"  >
					<tbody>
                    <tr valign="top">
                    <td align="left" rowSpan="2" width="72"  >
                    <img src="img/searchdb.png" height="105" border="0" title="" />
                    </td>
                    <td align="left" className="boxtitle" >Work Permit Applications</td>
                    </tr>
                    <tr>
                    <td align="left" className="boxtext" >View Work Permit Applications</td>
                    </tr>
					</tbody>
                    </table>
                    </a>
                </div>
		</div>


		{AD_USER!="" && 
       <div align="center"  className="numcols4-3" >
                <div className="rcorners">
                    <a href="#" onClick={(e)=>{openapp(e, 'lbr_clr_xtl')}}  >
                    <table border="0" width="100%"  >
					<tbody>
                    <tr valign="top">
                    <td align="left" rowSpan="2" width="72"  >
                    <img src="img/searchdb.png" height="105" border="0" title="" />
                    </td>
                    <td align="left" className="boxtitle" >Board<br/>Applications</td>
                    </tr>
                    <tr>
                    <td align="left" className="boxtext" >Board Applications</td>
                    </tr>
					</tbody>
                    </table>
                    </a>
                </div>
        </div>
		}
		
       <div align="center"  className="numcols4-4" >
                <div className="rcorners">

				{AD_USER!="" && 
                    <a href="#" onClick={(e)=>{openapp(e, 'agencyreg')}}  >
                    <table border="0" width="100%"  >
					<tbody>
                    <tr valign="top">
                    <td align="left" rowSpan="2" width="72"  >
                    <img src="img/searchdb.png" height="105" border="0" title="" />
                    </td>
                    <td align="left" className="boxtitle" >Agency<br/>Register</td>
                    </tr>
                    <tr>
                    <td align="left" className="boxtext" >View Agency<br/>Register</td>
                    </tr>
					</tbody>
                    </table>
                    </a>				
				}

                </div>
        </div>		
		
        <div align="center"  className="numcols4-1" >
                <div className="rcorners">
				
							
				{AD_USER=="ajones" &&
                    <a href="#" onClick={(e)=>{openapp(e, 'watchlist')}}  >
                    <table border="0" width="100%"  >
					<tbody>
                    <tr valign="top">
                    <td align="left" rowSpan="2" width="72"  >
                    <img src="img/searchdb.png" height="105" border="0" title="" />
                    </td>
                    <td align="left" className="boxtitle" >My Watch List</td>
                    </tr>
                    <tr>
                    <td align="left" className="boxtext" >My Watch List</td>
                    </tr>
					</tbody>
                    </table>
                    </a>
				}						
                </div>
		</div>

        <div align="center"  className="numcols4-2" >
                <div className="rcorners">

                    <a href="#" onClick={(e)=>{openapp(e, 'gvtapps')}}  >
                    <table border="0" width="100%"  >
					<tbody>
                    <tr valign="top">
                    <td align="left" rowSpan="2" width="72"  >
                    <img src="img/gvtapps.png" height="105" border="0" title="" />
                    </td>
                    <td align="left" className="boxtitle" >Government<br/>Applications</td>
                    </tr>
                    <tr>
                    <td align="left" className="boxtext" >Government Workers<br/>Applications</td>
                    </tr>
					</tbody>
                    </table>
                    </a>
                </div>
		</div>
		

		
        <div align="center"  className="numcols4-3" >
                <div className="rcorners">
				{AD_USER!="" &&
                    <a href="#" onClick={(e)=>{openapp(e, 'lbr_clr_app')}}  >
                    <table border="0" width="100%"  >
					<tbody>
                    <tr valign="top">
                    <td align="left" rowSpan="2" width="72"  >
                    <img src="img/searchdb.png" height="105" border="0" title="" />
                    </td>
                    <td align="left" className="boxtitle" >Labour Clearance</td>
                    </tr>
                    <tr>
                    <td align="left" className="boxtext" >Labour Clearance</td>
                    </tr>
					</tbody>
                    </table>
                    </a>
				}
				</div>
		</div>		

        <div align="center"  className="numcols4-4" >
                <div className="rcorners">
				{AD_USER!="" &&
                    <a href="#" onClick={(e)=>{openapp(e, 'registrations')}}  >
                    <table border="0" width="100%"  >
					<tbody>
                    <tr valign="top">
                    <td align="left" rowSpan="2" width="72"  >
                    <img src="img/searchdb.png" height="105" border="0" title="" />
                    </td>
                    <td align="left" className="boxtitle" >Portal Users registrations</td>
                    </tr>
                    <tr>
                    <td align="left" className="boxtext" >Portal Users registrations</td>
                    </tr>
					</tbody>
                    </table>
                    </a>
				}
                </div>

		</div>				
		
	
		
		
 		{AD_USER=="" && 
        <div align="center"  className="numcols4-1" >
                <div className="rcorners">
                   <a href="#" onClick={(e)=>{openapp(e, 'myprofile')}}  >
                    <table border="0" width="100%"  >
					<tbody>
                    <tr valign="top">
                    <td align="left" rowSpan="2" width="72"  >
                    <img src="img/searchdb.png" height="105" border="0" title="" />
                    </td>
                    <td align="left" className="boxtitle" >My Profile</td>
                    </tr>
                    <tr>
                    <td align="left" className="boxtext" >My Profile</td>
                    </tr>
					</tbody>
                    </table>
                    </a>			
                </div>
		</div>				
		}
		
		
		{AD_USER!="" && <>
        <div align="center"  className="numcols4-1" >
                <div className="rcorners">
                    <a href="#" onClick={(e)=>{openapp(e, 'wpusers')}}  >
                    <table border="0" width="100%"  >
					<tbody>
                    <tr valign="top">
                    <td align="left" rowSpan="2" width="72"  >
                    <img src="img/searchdb.png" height="105" border="0" title="" />
                    </td>
                    <td align="left" className="boxtitle" >System Users</td>
                    </tr>
                    <tr>
                    <td align="left" className="boxtext" >System Users</td>
                    </tr>
					</tbody>
                    </table>
                    </a>
                </div>

		</div>		
		
		
        <div align="center"  className="numcols4-2" >
                <div className="rcorners">
                    <a href="#" onClick={(e)=>{openapp(e, 'usergrp')}}  >
                    <table border="0" width="100%"  >
					<tbody>
                    <tr valign="top">
                    <td align="left" rowSpan="2" width="72"  >
                    <img src="img/searchdb.png" height="105" border="0" title="" />
                    </td>
                    <td align="left" className="boxtitle" >User Groups</td>
                    </tr>
                    <tr>
                    <td align="left" className="boxtext" >User Groups</td>
                    </tr>
					</tbody>
                    </table>
                    </a>
                </div>

		</div>				
  
		</>}

		
		{AD_USER=="ajones" && 
       <div align="center"  className="numcols4-3" >
                <div className="rcorners">
                    <a href="#" onClick={(e)=>{openapp(e, 'tbllbrclrrqs')}}  >
                    <table border="0" width="100%"  >
					<tbody>
                    <tr valign="top">
                    <td align="left" rowSpan="2" width="72"  >
                    <img src="img/searchdb.png" height="105" border="0" title="" />
                    </td>
                    <td align="left" className="boxtitle" >LC Request</td>
                    </tr>
                    <tr>
                    <td align="left" className="boxtext" >LC Request</td>
                    </tr>
					</tbody>
                    </table>
                    </a>
                </div>
        </div>
		}

		

		{AD_USER=="ajones" && 
       <div align="center"  className="numcols4-4" >
                <div className="rcorners">
                    <a href="#" onClick={(e)=>{openapp(e, 'tbllbrdcnrqs')}}  >
                    <table border="0" width="100%"  >
					<tbody>
                    <tr valign="top">
                    <td align="left" rowSpan="2" width="72"  >
                    <img src="img/searchdb.png" height="105" border="0" title="" />
                    </td>
                    <td align="left" className="boxtitle" >Decision Request</td>
                    </tr>
                    <tr>
                    <td align="left" className="boxtext" >Decision Request</td>
                    </tr>
					</tbody>
                    </table>
                    </a>
                </div>
        </div>
		}
		{
		AD_USER=="ajones" && <>
		 <a href="#" onClick={(e)=>{openapp(e, 'lbr_clr_decsn_export')}}  >Labour Clearance Decisions Exported</a>
		 <br/>
		 <a href="#" onClick={(e)=>{openapp(e, 'fileuploadbar')}}  >File Upload Bar</a>
		 <br/>
		 
		</>
		}
		{
		AD_USER=="ajones" && <>
		 <a href="#" onClick={(e)=>{openapp(e, 'sessvars')}}  >Session Variables</a>
		</>
		}
		
		
	
	<div id='snackbar' ></div>
	</>
);

}//end class

{
/*
onClick="document.getElementById('id01').style.display='none'"
onClick="document.getElementById('id01').style.display='none'"
*/
}

export default Appsmenu; 

